import React, { Component } from 'react';
import { NumberFormat, MonthInLetters } from '../../../../functions/generalFunctions';
import { pricesFormat } from '../../../../functions/pricesFormat';
import TableSalesTypeView from '../TableofSalesType/TableSalesTypeView';
import TableSalesPerSalesPersonView from '../TableofSalesPerSalesPerson/TableSalesPerSalesPersonView';
import TableDetailSalesPerRouteView from '../TableDetailSalesPerRoute/TableDetailSalesPerRouteView';
import TableofCurrentBalanceView from '../TableofCurrentBalance/TableofCurrentBalanceView';
import TableofExcessCustomerView from '../TableofExcessCustomer/TableofExcessCustomerView';
import TableHistoryCustomerView from '../TableHistoryCustomer/TableHistoryCustomerView';
import BarSalesDasboard from '../BarSalesDashboard/BarSalesDasboard';
import CalendarOfSales from '../CalendarOfSales/CalendarOfSales';
import {
    AiOutlineRise,
    AiOutlineFileText,
    AiOutlineWarning,
    AiOutlineTeam,
} from 'react-icons/ai';
import { FaChartBar } from 'react-icons/fa';

export default class DashTotalsView extends Component {

    formatCurrency = (n) =>
        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(n) || 0);

    render() {
        const { element, Father } = this.props;
        if (!element) return null;

        const { Totals, SalesPerRoute, SalesPerSalesPersons, SalesPerRouteDate,
                RouteYearSales, SalesByCustomer, SalesPerMonth,
                CurrentBalance, CustomerExcess, CustomerHistory,
                SalesPerRouteLoading, SalesPerRouteError,
                CurrentBalanceLoading, CurrentBalanceError,
                CustomerExcessLoading, CustomerExcessError } = element;

        const month = MonthInLetters(SalesPerRouteDate.getMonth() + 1) + ' ' + SalesPerRouteDate.getFullYear();

        // ── Derived KPI values ────────────────────────────────────────────────
        const sales         = (Totals && Totals.Sales)                    || {};
        const pending       = (Totals && Totals.TotalPendingInvoices)     || {};
        const customer      = (Totals && Totals.Customer)                 || {};
        const so            = (Totals && Totals.SalesOrder)               || {};
        const totalSales    = sales.Total           || 0;
        const totalInv      = sales.NoInvoices      || 0;
        const totalOverdue  = pending.TotalDueInv   || 0;
        const totalCustomers= customer.Total        || 0;
        const atRisk        = (customer.Risk || 0)  + (customer.Waring || 0);
        const pendingSOVal  = (so.NotStarted || 0)  + (so.InProcess    || 0);

        return (
            <div style={{ padding: '1.5rem 0' }}>

                {/* ── Page hero ─────────────────────────────────────────── */}
                <div style={{
                    background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #2563EB 100%)',
                    borderRadius: '16px',
                    padding: '2rem 2.5rem',
                    marginBottom: '1.75rem',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: '1rem',
                }}>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                            <FaChartBar style={{ fontSize: '1.75rem', opacity: 0.9 }} />
                            <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: '1.75rem', margin: 0 }}>
                                Company Totals
                            </h2>
                        </div>
                        <p style={{ margin: 0, opacity: 0.8, fontSize: '0.9375rem' }}>
                            Aggregated metrics across all sales representatives · {month}
                        </p>
                    </div>
                    <div style={{
                        background: 'rgba(255,255,255,0.1)',
                        border: '1px solid rgba(255,255,255,0.2)',
                        borderRadius: '10px',
                        padding: '0.5rem 1.25rem',
                        fontSize: '0.875rem',
                        fontWeight: 600,
                    }}>
                        All Sales People
                    </div>
                </div>

                {/* ── KPI metric cards ──────────────────────────────────── */}
                <div className="row g-3 mb-4">
                    <div className="col-6 col-md-4 col-lg-2">
                        <div className="metric-card status-success">
                            <p className="metric-label">
                                <AiOutlineRise style={{ marginRight: 4 }} />
                                Revenue
                            </p>
                            <div className="metric-value">{this.formatCurrency(totalSales)}</div>
                            <div className="metric-change status-success">{month}</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-4 col-lg-2">
                        <div className="metric-card status-primary">
                            <p className="metric-label">
                                <AiOutlineFileText style={{ marginRight: 4 }} />
                                Invoices
                            </p>
                            <div className="metric-value">{NumberFormat(totalInv)}</div>
                            <div className="metric-change" style={{ color: '#64748b' }}>issued this month</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-4 col-lg-2">
                        <div className="metric-card status-danger">
                            <p className="metric-label">
                                <AiOutlineWarning style={{ marginRight: 4 }} />
                                Overdue
                            </p>
                            <div className="metric-value">{this.formatCurrency(totalOverdue)}</div>
                            <div className="metric-change status-danger">past due balance</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-4 col-lg-2">
                        <div className="metric-card status-warning">
                            <p className="metric-label">
                                <AiOutlineTeam style={{ marginRight: 4 }} />
                                At-Risk
                            </p>
                            <div className="metric-value">{NumberFormat(atRisk)}</div>
                            <div className="metric-change status-warning">customers</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-4 col-lg-2">
                        <div className="metric-card status-primary">
                            <p className="metric-label">Customers</p>
                            <div className="metric-value">{NumberFormat(totalCustomers)}</div>
                            <div className="metric-change" style={{ color: '#64748b' }}>active total</div>
                        </div>
                    </div>
                    <div className="col-6 col-md-4 col-lg-2">
                        <div className="metric-card status-warning">
                            <p className="metric-label">Pending SOs</p>
                            <div className="metric-value">{NumberFormat(pendingSOVal)}</div>
                            <div className="metric-change status-warning">open orders</div>
                        </div>
                    </div>
                </div>

                {/* ── Row 1: Channel chart + Sales per person ───────────── */}
                {/* Components (TableSalesTypeView, TableSalesPerSalesPersonView) have their own
                    .card wrappers — no extra wrapper needed here                               */}
                <div className="row g-4 mb-4">
                    <div className="col-lg-6">
                        <TableSalesTypeView
                            SalesPerson={element.SalesPerson}
                            Father={Father}
                            Date={SalesPerRouteDate}
                            Month={month}
                            Title={'Sales by Distribution Channel'}
                            data={SalesPerRoute}
                            loading={SalesPerRouteLoading}
                            error={SalesPerRouteError}
                            showMonths
                        />
                    </div>
                    <div className="col-lg-6">
                        <TableSalesPerSalesPersonView
                            SalesPerson={element.SalesPerson}
                            Father={Father}
                            Date={SalesPerRouteDate}
                            Month={month}
                            Title={'Sales by Sales Person'}
                            data={SalesPerSalesPersons}
                        />
                    </div>
                </div>

                {/* ── Row 3: Sales by Customer + Calendar ──────────────── */}
                <div className="row g-4 mb-4">
                    <div className="col-lg-6">
                        <TableDetailSalesPerRouteView
                            Title={'Sales by Customer'}
                            data={SalesByCustomer}
                        />
                    </div>
                    <div className="col-lg-6">
                        <CalendarOfSales
                            Father={Father}
                            Totals={sales}
                            Date={SalesPerRouteDate}
                            SalesPerson={element.SalesPerson}
                            data={SalesPerMonth}
                            Title={'Sales Per Day'}
                        />
                    </div>
                </div>

                {/* ── Row 4: Overdue + Excess credit ───────────────────── */}
                <div className="row g-4 mb-4">
                    <div className="col-lg-6">
                        <TableofCurrentBalanceView
                            Title={'Past Due Invoices'}
                            Totals={pending}
                            data={CurrentBalance}
                            loading={CurrentBalanceLoading}
                            error={CurrentBalanceError}
                        />
                    </div>
                    <div className="col-lg-6">
                        <TableofExcessCustomerView
                            Title={'Customers with Exceeded Credit Limit'}
                            data={CustomerExcess}
                            loading={CustomerExcessLoading}
                            error={CustomerExcessError}
                        />
                    </div>
                </div>

                {/* ── Row 5: Customer history ───────────────────────────── */}
                <div className="row g-4 mb-4">
                    <div className="col-12">
                        <TableHistoryCustomerView
                            Title={'Days of Last Sale — All Customers'}
                            Totals={customer}
                            data={CustomerHistory}
                        />
                    </div>
                </div>

                {/* ── Row 6: Year bar chart (hidden when empty) — last section ── */}
                {RouteYearSales && RouteYearSales.length > 0 && (
                    <div className="row g-4">
                        <div className="col-12">
                            <div className="card" style={{ borderRadius: '14px', border: '1px solid #e2e8f0' }}>
                                <div className="card-body">
                                    <BarSalesDasboard Title="Annual Sales Overview" Data={RouteYearSales} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        );
    }
}
